import {
  createContext,
  FC,
  Fragment,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import PlanModal from "./PlanModal";

export interface IUpgradePlanContext {
  open: boolean;
  handleModalOpen: () => void;
  handleModalClose: () => void;
}

export const UpgradePlanContext = createContext<IUpgradePlanContext>(
  {} as IUpgradePlanContext
);

export const UpgradePlanProvider: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const handleModalOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleModalClose = useCallback(() => setOpen(false), [setOpen]);

  const value = useMemo(() => {
    return {
      open,
      handleModalOpen,
      handleModalClose,
    };
  }, [open, handleModalOpen, handleModalClose]);

  return (
    <Fragment>
      <UpgradePlanContext.Provider value={value}>
        {children}
      </UpgradePlanContext.Provider>
      <PlanModal open={open} onhandleClose={handleModalClose} />
    </Fragment>
  );
};

export const useUpgradePlanContext = () => {
  return useContext(UpgradePlanContext);
};

export default UpgradePlanContext;
